module.exports = __webpack_public_path__ + "img/gok_token.gods.ede05bc.png";